import {useSetRecoilState} from "recoil";
import {tokenState} from "@/atom/tokenState.jsx";
import {useEffect} from "react";
import {getCookie} from "@/util/cookieUtil.js";
import {userState} from "@/atom/userState.jsx";

const TokenInitializer = () => {
    const setToken = useSetRecoilState(tokenState)
    const setUser = useSetRecoilState(userState)

    useEffect(() => {
        const accessToken = getCookie("accessToken");
        const refreshToken = getCookie("refreshToken");
        const user = getCookie("user");
        if (accessToken !== null) {setToken({accessToken: accessToken,refreshToken: refreshToken});}
        if (user != null) {
            const userInfo = user
            setUser({...user});
        }
    }, [setToken]);

    return null;
}

export default TokenInitializer;